// Su misura: come funziona e richiesta diretta all'artigiano
import React from 'react';
import { MessageSquare, PenLine, Package, Sparkles } from 'lucide-react';
import { optimizeImageUrl } from '../../utils/imageUrl';
import { useShop } from '../ShopContext';
import { PageHeader, PrimaryButton, Section } from '../ShopUi';

const STEPS = [
  { icon: PenLine, title: 'Racconta la tua idea', text: 'Descrivi cosa desideri, aggiungi foto di ispirazione, budget e tempi.' },
  { icon: MessageSquare, title: 'Ricevi la proposta', text: 'Ti rispondo con prezzo, tempi di realizzazione e come la realizzerei.' },
  { icon: Package, title: 'Creo il tuo pezzo', text: 'Accetti e paghi in modo protetto: il pezzo viene realizzato e spedito a te.' },
];

export default function ShopCustom() {
  const { name, style, portfolio, openRequest } = useShop();
  return (
    <div data-testid="shop-custom">
      <PageHeader title="Creazioni su misura" subtitle={`Un pezzo unico, pensato per te da ${name}.`} />
      <Section>
        <div className="grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div key={s.title} className={`p-6 ${style.panel} ${style.centered ? 'text-center' : ''}`}>
              <div className={`w-11 h-11 rounded-full bg-shop-primary/10 text-shop-primary flex items-center justify-center ${style.centered ? 'mx-auto' : ''}`}>
                <s.icon className="w-5 h-5" />
              </div>
              <p className="mt-4 text-xs font-semibold text-shop-primary">Passo {i + 1}</p>
              <h3 className={`${style.heading} text-lg text-slate-900 mt-1`}>{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{s.text}</p>
            </div>
          ))}
        </div>
        <div className={`mt-10 ${style.centered ? 'text-center' : ''}`}>
          <PrimaryButton onClick={openRequest} data-testid="shop-custom-request-btn"><Sparkles className="w-4 h-4" /> Racconta la tua idea</PrimaryButton>
        </div>
      </Section>
      {portfolio.length > 0 && (
        <Section title="Lavori su misura già realizzati">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {portfolio.slice(0, 8).map((item) => (
              <figure key={item.id} className={`${style.media} overflow-hidden bg-slate-100 aspect-square`}>
                <img src={optimizeImageUrl(item.image_url, 500)} alt={item.title} className="w-full h-full object-cover" />
              </figure>
            ))}
          </div>
        </Section>
      )}
    </div>
  );
}
